/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { UNIT_TYPES } from 'constants'

export const CREATE_UNIT_BUTTON_TOOLTIP_TITLE = (periphery) => (
    <FormattedMessage
        id='battle_rooms.create_unit_button_tooltip.title'
        defaultMessage='Сражения на сервере {periphery} недоступны'
        values={{ periphery }}
    />
)

export const UNAVAILABLE_BATTLE_MESSAGES = availableTime => {
    return ({
        [UNIT_TYPES.SORTIE]: (
            <FormattedMessage
                id='battle_rooms.create_unit_button_tooltip.unavailable_battle.message.sortie'
                defaultMessage='Ближайшие Вылазки: {availableTime} на сервераx:'
                values={{ availableTime }}
            />
        ),
        [UNIT_TYPES.FORT_BATTLE]: (
            <FormattedMessage
                id='battle_rooms.create_unit_button_tooltip.unavailable_battle.message.fort_battle'
                defaultMessage='Ближайшие Наступления: {availableTime} на серверax:'
                values={{ availableTime }}
            />
        ),
    })
}

export const UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = {
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='battle_rooms.create_unit_button_tooltip.unavailable_battle.available_servers.sortie'
            defaultMessage='Сейчас Вылазки доступны на серверах:'
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='battle_rooms.create_unit_button_tooltip.unavailable_battle.available_servers.fort_battle'
            defaultMessage='Сейчас Наступления доступны на серверах:'
        />
    ),
}

export const UNAVAILABLE_BATTLE_UNAVAILABLE_SERVERS = {
    [UNIT_TYPES.SORTIE]: (
        <FormattedMessage
            id='battle_rooms.create_unit_button_tooltip.unavailable_battle.unavailable_servers.sortie'
            defaultMessage='Время начала Вылазок станет известно позже'
        />
    ),
    [UNIT_TYPES.FORT_BATTLE]: (
        <FormattedMessage
            id='battle_rooms.create_unit_button_tooltip.unavailable_battle.unavailable_servers.fort_battle'
            defaultMessage='Время начала Наступлений станет известно позже'
        />
    ),
}

export const CHANGE_PERIPHERY_MESSAGE = (icon) => (
    <FormattedMessage
        id='battle_rooms.create_unit_button_tooltip.change_periphery'
        defaultMessage='To select a different server, click the {icon} icon in the bottom right corner.'
        values={{ icon }}
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/CreateUnitButtonTooltip/constants.jsx